<!-- 
Card for displaying a bulk-provider task.
-->
<template>
  <div>
    <v-hover class="mt-2 mb-3">
      <v-card 
        slot-scope="{ hover }"
        :v-ripple="canRunTask(task.claimType)"
        :style="canRunTask(task.claimType) ? 'cursor:pointer' : 'cursor:default'"
        :class="canRunTask(task.claimType) ? '' : 'grey--text text--darken-1'"
        flat
        @click.stop="run"
        @keydown.enter="run"
      >
        <div v-if="hover && canRunTask(task.claimType)" class="d-flex reveal"/>
        <v-card-text class="pb-0">
          <h3 :class="muted ? 'subheading mb-3' : 'title mb-3'">
            <v-icon v-if="!muted" :color="hover && canRunTask(task.claimType) ? 'primary' : ''" class="mr-2">{{ getIcon(task.type) }}</v-icon>
            {{ lookups.providerTaskTypeDescriptions[task.type] }}
            <v-tooltip v-if="!canRunTask(task.claimType)" bottom>
              <v-icon slot="activator" color="red darken-4" class="subheading lock">lock</v-icon>
              <span>You do not have permission to run this task</span>
            </v-tooltip>
          </h3>
          <v-layout>
            <v-flex class="hidden-xs-only" style="flex: 0 0 120px;">
              <v-progress-circular
                v-if="task.applicableCount + task.notApplicableCount" 
                :rotate="-90" :value="getTaskProgress(task)" :color="getTaskColour(task)" 
                :size="muted ? 80 : 100" :width="muted ? 4 : 5"
                class="mr-3"
              >
                {{ task.applicableCount }}/{{ task.applicableCount + task.notApplicableCount }}
              </v-progress-circular>
            </v-flex>
            <v-flex>
              <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component vue/no-v-html -->
              <p v-html="task.description"/>
              <p class="font-weight-medium">
                {{ getApplicabilityDescription(task) }}
              </p>
              <task-applicability :task="task" />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions v-if="canRunTask(task.claimType)" class="pt-0">
          <v-spacer/>
          <v-btn flat color="primary">{{ lookups.providerTaskTypeDescriptions[task.type] }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-hover>
  </div>
</template>

<script>
import lookupMixins from "@/mixins/lookup.mixins";
import TaskApplicability from "./TaskApplicability.vue";
import taskMixins from "@/mixins/task.mixins";

export default {
  components: { TaskApplicability },
  mixins: [lookupMixins, taskMixins],
  props: {
    task: {
      required: true,
      type: Object
    },
    muted: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    run() {
      if (this.canRunTask(this.task.claimType)) {
        this.$emit("run", this.task);
      }
    }
  }
};
</script>
